import React from "react";
import Typical from "react-typical";
// ...existing code...
import { scrollToSection } from "../../../utilities/commonUtils";
import "./Profile.css";

function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <a href="https://www.linkedin.com/in/aashi-jain-671a3b321/">
                <i className="fa fa-linkedin-square"></i>
              </a>
              <a href="https://leetcode.com/u/AashiJain971/">
                <i className="fa fa-code"></i>
              </a>
              <a href="https://github.com/AashiJain971">
                <i className="fa fa-github"></i>
              </a>
              <a href="mailto:aashijainbid@gmail.com">
                <i className="fa fa-envelope"></i>
              </a>
            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              Hello I'm <span className="highlighted-text">Aashi Jain</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              <h1>
                <Typical
                  loop={Infinity}
                  steps={[
                    "Student 📚",
                    2000,
                    "Software Developer Engineer ⚡",
                    2000,
                    "Machine Learning Engineer 🚀",
                    2000,
                    "Full Stack Developer 💎",
                    2000,
                    "MERN Stack Developer 🔥",
                    2000,
                  ]}
                />
              </h1>
            </span>
            <span className="profile-role-tagline">
              Building menaingful and impactful software soltuions
            </span>
          </div>
          <div className="profile-options">
            <button
              className="btn primary-btn"
              onClick={() => scrollToSection("Contact Me")}
            >
              Get In Touch{" "}
            </button>
            <a
              href="https://drive.google.com/file/d/1X5ixtIuUrVezV_quhXmX67ZWmA3zNxVW/view?usp=drive_link"
            >
              <button className="btn highlighted-btn">My Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}

export default Profile;